<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @search="search"
                @reflash="reflash"
                @del="delall"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="datajson"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                header-row-class-name="headerclass"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column  type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Exclusively_Id" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_NAME" :label="$t('getapi[3331]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_Description" :label="$t('getapi[2141]')"></el-table-column>
            <el-table-column prop="Price1" :label="$t('getapi[7924]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.Price1 | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Price1REMARK" :label="$t('getapi[2720]')"></el-table-column>
            <el-table-column prop="Price2" :label="$t('getapi[7925]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.Price2 | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Price2REMARK" :label="$t('getapi[2721]')"></el-table-column>
            <el-table-column prop="Price3" :label="$t('getapi[7926]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.Price3 | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Price3REMARK" :label="$t('getapi[7972]')"></el-table-column>
            <el-table-column prop="Price4" :label="$t('getapi[12839]')" align="right">
                <template slot-scope="scope">
                    {{scope.row.Price4 | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Price4REMARK" :label="$t('getapi[12840]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="REMARK" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[6109]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            <!--</el-col>-->
        </el-row>
        <selector :isVisible="rouvisible" :isSplitPage="true" :postUrl="'Basic/Items/GetRoutingTypePopupList'"
                  @callback="getrout" ref="routs"></selector>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('getapi[2020]')">
                    <el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
                        <el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')" width="150"></el-table-column>
                        <el-table-column show-overflow-tooltip :label="$t('getapi[2022]')">
                            <template slot-scope="scope">
                                <input type="text" v-model="scope.row.query_Condition" style="border:none" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[2028]')"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 搜索弹框 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false" :modal-append-to-body="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[3331]')}}</td>
                        <td>
                            <routejump :urlNo="14" :isDialog="1" @callback="beforeRoutJump">
                            <el-input v-model="formInline.WORKPROC_NAME" type="text" readonly class="mcolor" size="mini">
                                <i class="el-icon-edit el-input__icon" slot="suffix"
                                   @click="showrout()"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[2141]')}}</td>
                        <td><el-input v-model="formInline.WORKPROC_Description"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7924]')}}</td>
                        <td>
                            <el-input v-model="formInline.Price1" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        </td>
                        <td>{{$t('getapi[2720]')}}</td>
                        <td>
                            <el-input v-model="formInline.Price1REMARK"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7925]')}}</td>
                        <td><el-input v-model="formInline.Price2" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                        <td>{{$t('getapi[2721]')}}</td>
                        <td>
                            <el-input v-model="formInline.Price2REMARK"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7926]')}}</td>
                        <td><el-input v-model="formInline.Price3" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                        <td>{{$t('getapi[7972]')}}</td>
                        <td>
                            <el-input v-model="formInline.Price3REMARK"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12839]')}}</td>
                        <td><el-input v-model="formInline.Price4" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                        <td>{{$t('getapi[12840]')}}</td>
                        <td>
                            <el-input v-model="formInline.Price4REMARK"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[143]')}}</td>
                        <td><el-input v-model="formInline._remark"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <!-- 编辑弹框 -->
    </div>
</template>

<script>
    import Common from '@/components/Common';
    export default {
        name: 'wxroutingprice',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                formInline: {
                    Exclusively_Id: 0,
                    WORKPROC_CODE: "",
                    WORKPROC_NAME: "",
                    CREATE_PERSON: "",
                    CREATE_TIME: "",
                    LATEST_MODIFY_PERSON: "",
                    LATEST_MODIFY_TIME: "",
                    REMARK: "",
                    enable_flag: 0,
                    Price1: 0,
                    Price2: 0,
                    Price3: 0,
                    WORKPROC_Description: "",
                    Price1REMARK:null,
                    Price2REMARK:null,
                    Price3REMARK:null
                },
                oldFormInline:{},
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true ,// 是否新增
                btn: {
                    del: false,
                    edit: false
                },
                scrollTop:0,
            };
        },
        create() {},
        beforeMount() {
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[7923]"),this.$t("getapi[13]"));
            },
            //按钮操作权限
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh');
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                that.$http.urlpost('/Basic/Iss/Iss_Routing_PriceDataList', '', function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            sava() {
                let that = this;
                that.loading = true;
                let parm = new Array();
                parm.push(that.formInline);
                console.log(JSON.stringify(parm));
                that.$http.urlpost('/Basic/Iss/SaveIss_Routing_Price', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.editvisi = false;
                        that.intidata();
                    }
                    that.loading = false;
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
                    that.queryData = res.DataContent;
                });
            },
            // 编辑
            edit(jsd) {
                let that = this
                let datetime = Common.methods.getDatetime()
                this.editvisi = true;
                this.formInline = {
                    Exclusively_Id: jsd.row.Exclusively_Id,
                    WORKPROC_CODE: jsd.row.WORKPROC_CODE,
                    WORKPROC_NAME: jsd.row.WORKPROC_NAME,
                    CREATE_PERSON: jsd.row.CREATE_PERSON,
                    CREATE_TIME: jsd.row.CREATE_TIME,
                    LATEST_MODIFY_PERSON: that.user,
                    LATEST_MODIFY_TIME: jsd.row.LATEST_MODIFY_TIME,
                    REMARK: jsd.row.REMARK,
                    enable_flag: jsd.row.enable_flag,
                    Price1: jsd.row.Price1,
                    Price2: jsd.row.Price2,
                    Price3: jsd.row.Price3,
                    Price4: jsd.row.Price4,
                    WORKPROC_Description: jsd.row.WORKPROC_Description,
                    Price1REMARK:jsd.row.Price1REMARK,
                    Price2REMARK:jsd.row.Price2REMARK,
                    Price3REMARK:jsd.row.Price3REMARK,
                    Price4REMARK:jsd.row.Price4REMARK
                };
                this.oldFormInline = JSON.stringify(this.formInline)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                console.log(parm);
                that.$http.urlpost('/Basic/Iss/BatchDeleteIss_Routing_Price', parm, function(res) {
                    that.intidata();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_Id + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {});
            },
            // 新增
            add() {
                let that = this
                let datetime = Common.methods.getDatetime()
                this.formInline = {
                    Exclusively_Id: 0,
                    WORKPROC_CODE: "",
                    WORKPROC_NAME: "",
                    CREATE_PERSON: "",
                    CREATE_TIME: "",
                    LATEST_MODIFY_PERSON: that.user,
                    LATEST_MODIFY_TIME: datetime,
                    REMARK: "",
                    enable_flag: 0,
                    Price1: '',
                    Price2: '',
                    Price3: '',
                    Price4: '',
                    WORKPROC_Description: "",
                    Price1REMARK:'',
                    Price2REMARK:'',
                    Price3REMARK:'',
                    Price4REMARK:''
                };
                this.editvisi = true;
            },
            // 查询
            search() {
                this.isVisible = true;
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            showrout() {
                let that = this;
                this.$refs.routs.clearInput(true);
            },
            //获取工序信息
            getrout(val) {
                this.formInline.WORKPROC_CODE = val.workproc_code;
                this.formInline.WORKPROC_NAME = val.workproc_name;
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.editvisi = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.editvisi = false
                    callback(true)
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
